module.exports = __webpack_public_path__ + "img/icon_tel.42399dc7.png";